/**
 * Created by idea on 06/04/2017.
 */
import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private router: Router) {
    }
    route: any = {}

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let url = next.routeConfig.path;
        // let isShop = localStorage.getItem('isShop');
        var timestamp = Math.round(Date.now() / 1000);
        
        // var arrayIsShop = ['product','product/add','order/shop','order_free','customers_shop','vendors','brands','shipping','bill_info','history/warehouse','history/payment','dashboard','income_shop', 'sprofile'];

        if (!this.isAuthenticated()) {
            localStorage.clear();
            sessionStorage.clear();
            this.router.navigate(['/login'], {queryParams: {returnUrl: state.url}});
            return false;
        }
        if (localStorage.getItem('Access-Token') && localStorage.getItem('Access-Token-Icheck')) {
            const user_info = JSON.parse(localStorage.getItem('User'));
            for(let i=0; i<this.router.config[1].children.length; i++){
                var child = this.router.config[1].children[i];
                if(child.path == url){
                    this.route = child;
                }
            }
            if(this.route.data && this.route.data.role.indexOf(user_info.role) === -1){
                this.router.navigate(['/dashboard']);
                return false;
            }
            // if(!flag){
            //     this.router.navigateByUrl('/dashboard');
            //     return false;
            // }
            // if(isShop == 'false'){
            //     if( arrayIsShop.indexOf(url) >= 0){
            //         this.router.navigate(['/permission/error']);
            //         return false;
            //     }
            // }
            return true;
        }
        
        this.router.navigate(['/login'], {queryParams: {returnUrl: state.url}});
        return false;
    }

    isAuthenticated() {
        const expiresAt = JSON.parse(localStorage.getItem('expires_at'));
        return Date.now() + 60000 < expiresAt;
    }
}


// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/common/services/Auth.guard.ts